import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import MovieClub from "@components/MovieClub";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const MovieClubPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;

    return (
        <VersionedLayout>
            <Helmet>
                <title>{`Movie Club Membership | Exclusive Offers | ${brand}`}</title>
                <meta name="description" content="Discover the perks of our membership for movies. Enjoy cheaper tickets, free movie sessions & more at nearby independent or regional cinema. Sign up today!" />
                <link rel="canonical" href={`${window.location.protocol}//${window.location.host}/movie-club-membership`} />
            </Helmet>
            <MovieClub />
        </VersionedLayout>
    );
};

export default MovieClubPage;
